import type { QuestionSubType } from '@mentimeter/http-clients';
import { useIdentifiedScalesResults } from '@mentimeter/presentation-data-hooks/results/identified/scales';
import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import type { ScalesT } from '@mentimeter/question-modules-types';
import { ScalesPresentation } from './ScalesPresentation';

export function ScalesPresentationDataHandler() {
  const {
    useQuestion,
    useResults,
    useTrends,
    useSeries,
    useCurrentSession,
    useConfig,
    InteractiveCanvasComponents,
  } = usePresentationContext();

  const {
    admin_key,
    sub_type,
    choices,
    range,
    hide_results,
    dimensions,
    scales_total_average,
  } = useQuestion();

  const { showTrends } = useTrends();
  const { results, respondents } = useResults<ScalesT>();
  const { participation_identity_mode, participation_identity_visibility } =
    useSeries();
  const { isCurrentSessionActive } = useCurrentSession();
  const { enableAnimations } = useConfig();

  const notSupportedSubTypes: QuestionSubType[] = ['spider'];
  const isSubTypeWithIdentifiedResponses =
    !notSupportedSubTypes.includes(sub_type);

  const hasIdentifiedResultsSettingOn =
    participation_identity_mode === 'identified' &&
    participation_identity_visibility === 'everyone';

  const shouldFetchIdentifiedResults =
    hasIdentifiedResultsSettingOn &&
    isSubTypeWithIdentifiedResponses &&
    isCurrentSessionActive;

  const { data: identifiedResults } = useIdentifiedScalesResults(
    admin_key,
    shouldFetchIdentifiedResults,
  );

  return (
    <ScalesPresentation
      identifiedResults={identifiedResults?.results}
      choices={choices}
      range={range}
      sub_type={sub_type}
      numberOfRespondents={respondents}
      results={results}
      shouldHideResults={hide_results}
      shouldShowTrends={showTrends}
      dimensionLabels={{ min: dimensions[0].min, max: dimensions[0].max }}
      shouldShowOverallAverage={scales_total_average}
      shouldAnimate={enableAnimations}
      CanvasVisualizationArea={
        InteractiveCanvasComponents?.CanvasVisualizationArea
      }
    />
  );
}
